module.exports = __webpack_public_path__ + "img/blob1.9c7254b3.svg";